(function ($) {
    $('.expand-affiliate').on('click',function(e){
        e.preventDefault();
        $(this).parents('.affiliates-linkbox').removeClass('is-close');
    });
    $('.close-affiliate').on('click',function(e){
        e.preventDefault();
        $(this).parents('.affiliates-linkbox').addClass('is-close');
    });
})(jQuery);

